import React from "react";

function TextInputP({
  label,
  id,
  placeholder,
  required,
  type,
  register,
  defaultValue,
  pattern,
  minLength,
  disabled = false,
  width = null,
  maxLength,
  ...props
}) {
  return (
    <div
      className={`${width ? `mymd:w-[${width}] w-full` : "w-full"} ${
        props.mb
          ? `relative mb-${props.mb} w-full`
          : `relative mb-[28px] w-full`
      }`}
    >
      <label htmlFor={id} className="text-[14px] font-[500] pl-1">
        <>
          {required ? (
            <>
              {label}
              &nbsp;<span className="text-red-600">*</span>
            </>
          ) : (
            <>{label}</>
          )}
        </>
      </label>
      <input
        type={type}
        id={id}
        maxLength={maxLength ? maxLength : ""}
        className={`${
          width ? `mymd:w-[${width}] w-full` : "w-full"
        } peer bg-[#F4F6F9] ${
          pattern && props?.errors[id]
            ? "border-[1px] border-danger ring-1 ring-danger"
            : "border-[1px] border-[#C5C5C7]"
        }  text-gray-900 text-[13px] rounded-lg h-[40px] focus:ring-1 focus:ring-primary placeholder-gray-400 focus:border-primary focus:border-[1px] block p-2.5 mt-1 font-medium`}
        placeholder={placeholder}
        defaultValue={defaultValue}
        {...register(id, {
          required: required,
          pattern: pattern,
          minLength: +minLength,
          maxLength: new Number(maxLength),
        })}
        disabled={disabled}
      />

      {props.errors && props.errors[id] && (
        <p className="absolute mt-[2px] text-danger text-[11px] font-[500]">
          {props.errors[id]?.type === "pattern" && "Input is invalid"}
          {props.errors[id]?.type === "required" && "Field is required"}
        </p>
      )}
    </div>
  );
}

export default TextInputP;
